<template>
    <div v-click-outside="onclickOutside">
        <div>
            <button type="button" @click="toggleShowProfileMenu" 
                class="flex text-sm py-2 px-3 rounded-lg focus:ring-1 focus:ring-gray-300 dark:focus:ring-gray-600 hover:bg-gray-100"
                aria-expanded="false" data-dropdown-toggle="dropdown-user">
                <span class="sr-only">Open user menu</span>
                <div class="flex flex-row gap-4 items-center">
                    <img class="h-10 w-10 rounded-full border"
                    src="@/assets/bdglogistica_isotipo_profile.png"
                    alt="user photo">

                    <div class="text-left">
                        <p class="font-bold text-gray-900 dark:text-white capitalize">{{ fullName }}</p>
                        <p class="text-sm font-medium text-gray-900 truncate dark:text-gray-300">{{ username }}</p>
                    </div>

                    <font-awesome-icon icon="fa-solid fa-chevron-down" class="h-5 w-8 text-gray-500 transition-transform duration-300 transform" />
                </div>
            </button>
        </div>
        <div
            class="z-50 my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600 "
            :class="{'absolute top-14 right-8': showProfileMenu, 'hidden': !showProfileMenu}">
            
            <ul class="py-1" role="none">
                <li>
                    <button type="button" @click="onLogout"
                        class="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                        role="menuitem">Cerrar sesión</button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue'
    import router from '@/router'
    import useAuth from '@/modules/auth/composables/useAuth'
    import vClickOutside from 'click-outside-vue3'
    
    export default {
        directives: {
        clickOutside: vClickOutside.directive,
    },
        setup() {
            const showProfileMenu = ref(false)
            const { fullName, username, logout } = useAuth()

            return {
                fullName,
                username,
                showProfileMenu,
                onLogout: () => {
                    router.push({ name: 'login'})
                    logout()
                },
                toggleShowProfileMenu: () => {
                    showProfileMenu.value = !showProfileMenu.value
                },
                onclickOutside: () => {
                    showProfileMenu.value = false
                }
            }
        },
    }
</script>